/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Companycity1Inputs */

const en_entity_companycity1 = /** @type {(inputs: Entity_Companycity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company City`)
};

const de_entity_companycity1 = /** @type {(inputs: Entity_Companycity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Firmenstadt`)
};

/**
* | output |
* | --- |
* | "Company City" |
*
* @param {Entity_Companycity1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_companycity1 = /** @type {((inputs?: Entity_Companycity1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Companycity1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_companycity1(inputs)
	return de_entity_companycity1(inputs)
});
export { entity_companycity1 as "entity_companyCity" }